"use strict";const e=new Map,s=(t,r)=>{e.set(t,r)},n=t=>e.get(t);export{s as registerFeature,n as getFeature};
//# sourceMappingURL=FeaturesRegistry.js.map
